import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { resendUserWelcomeEmail } from '../../services/SuperAdminLearnerService';
import { toast } from 'react-toastify';
import Loader from '../../utility/Loader';

export default function SuperAdminResendInvite() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({user: {first_name: ""}});
    const [user, setUser] = useState({});
    useEffect(() => {
        const userDetails = getUserDetails();
        if(userDetails.token === undefined){
          navigate('/login');
        }else{
           
           
        }
        
    },[]);

    const handleValueChange = (e) => {
        const { name, value } = e.target;
        setUser({
          ...user,
          [name]: value,
        });
    };

    const validateUser = (user) => {
        return !(user.email === undefined || user.email === null || user.email === '' || user.password === undefined || user.password === null || user.password === '');
    };

    const inviteUser = async () => {
        const userDetails = getUserDetails();
        const isValid = validateUser(user);

        if(isValid){
            setLoading(true);
            const resp = await resendUserWelcomeEmail(userDetails.token, { email: user.email, newpassword: user.password });
            if(resp.error){
                toast.error(resp.data);
            }else{
                toast.success(resp.data || "Email Sent!");
                setUser({ email: "", password: "" });
            }
            setLoading(false);
        }else{
            toast.warn("Please provide both Email and Password.");
        }
        
    };

    


    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className='lg:py-10 lg:px-24 xl:px-32 py-10 px-10'>
                <h3 className='text-2xl text-secondary inter-700 mb-6 lg:hidden pt-6 lg:pt-0 px-6'>Invite New Learner</h3>
                <div className='back-btn flex justify-start mb-5 md:mb-8'>
                    <a onClick={() => navigate('/superadmin/managelearners')} className='cursor-pointer w-auto bg-tertiary hover:bg-black flex items-center justify-center px-6 h-7 2xl:h-8 text-white inter-500 text-xs 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Back</a>
                </div>
                <form className='w-full'>

                    <div className='w-full lg:py-10 lg:px-12 py-6 px-6'>
                        <div className='flex justify-between flex-wrap items-end'>
                            <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Email</label>
                                <input type='email' name="email" value={user.email} onChange={handleValueChange} placeholder='Email' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300'/>
                            </div>
                            <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Password</label>
                                <input type='password' name="password" value={user.password || ''} onChange={handleValueChange} placeholder='Password' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300'/>
                            </div>
                            <div className='w-full md:w-[18%] mb-5 md:mb-8 flex md:justify-end'>
                                <button onClick={inviteUser} type="button" className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-8 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Resend Invite Email</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            )}
        </div>
    );
}
